import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import store from "../../store";
import { userSetInformations } from "../../actions/userActions";
import { appFlushDatas, appOnLoginPage } from "../../actions/appActions";
import { initAxiosInstanceToken } from "../../utils/axios";
import loginApi from "../../api/loginApi";
import appApi from "../../api/appApi";
import Login from "../views/login/Login";
import { baseAppRouter } from "../../utils/config";
import { saveToLocalStorage } from "../../utils/localStorageManager";

class LoginContainer extends Component {
	constructor(props) {
		super(props);
		this.state = { loginAnnouncement: "" };
		this.login = this.login.bind(this);
	}

	componentDidMount() {
		store.dispatch(appFlushDatas());
		store.dispatch(appOnLoginPage());

		appApi.getAnnouncement().then((announcement) => {
			this.setState({loginAnnouncement:announcement})
		})
	}

	login(user, password, env) {
		loginApi
			.login(user, password, env)
			.then(userInformations => {
				store.dispatch(
					userSetInformations(
						userInformations.login,
						userInformations.superAdmin,
						userInformations.targetDirectories,
						userInformations.token,
						userInformations.environment,
						userInformations.accountMetadataLabel,
						userInformations.uipreferences,
						userInformations.uploadEnabled
					)
				);
				saveToLocalStorage("userInformations", userInformations);
				initAxiosInstanceToken(userInformations.token);
				store.dispatch(appOnLoginPage());
				if (userInformations.superAdmin) {
					appApi.getUserList().then(userList => {
						saveToLocalStorage("userList", userList);
						this.props.history.push(baseAppRouter + "runningTasks");
					});
				} else {
					this.props.history.push(baseAppRouter + "runningTasks");
				}
			})
			.catch(err => {
				// errorUtils.dispatchErrorWithTimeout("Login error" + err);
			});
	}
	render() {
		return (
			<div className="home-page">
				<Login
					isLogin={this.props.isLogin}
					login={this.login}
					loginAnnouncement={this.state.loginAnnouncement}
				/>
			</div>
		);
	}
}

const mapStateToProps = function(store) {
	return {
		isLogin: store.loginState.isLogin,
		logged: store.loginState.logged
	};
};

LoginContainer.propTypes = {
	isLogin: PropTypes.bool.isRequired,
	logged: PropTypes.bool.isRequired
};

LoginContainer.contextTypes = {
	router: PropTypes.shape({
		history: PropTypes.object.isRequired
	})
};

export default connect(mapStateToProps)(LoginContainer);



// WEBPACK FOOTER //
// ./src/components/container/LoginContainer.js